import { queryDictExpend, queryDictIncome } from '@api/core/dict';

// 按模块的action, reducer整合体
/**
 * 获取支出类别
 */
const pType = [
  { value: '1[1,2]_', key: '一、经营性现金流入', color: 'green' },
  { value: '11_', key: '(一)日常现金流入' },
  { value: '12_', key: '(二)非日常现金流入' },
  { value: '13_', key: '二、筹资性现金流入', color: 'green' },
  { value: '14_', key: '三、投资性现金流入', color: 'green' },
  { value: '1__', key: '现金流入合计', color: 'red' },
  { value: '2[1,2]_', key: '四、经营性现金流出', color: 'green' },
  { value: '21_', key: '(一)日常现金流出' },
  { value: '22_', key: '(二)非日常现金流出' },
  { value: '23_', key: '五、投资性现金流出', color: 'green' },
  { value: '2__', key: '现金流出合计', color: 'red' },
  { value: '1[1,2]_-2[1,2]_', key: '经营性现金净流（总）', color: 'red' },
  {
    value: '[210,211,212,21e,21w,216]',
    key: '人力资源成本',
    color: 'red',
    children: [210, 211, 212, '21e', '21w', 216],
  },
  { value: '11_-21_', key: '经营性现金净流（日常）', color: 'red' },
  { value: '12_-22_', key: '经营性现金净流（非日常）', color: 'red' },
  { value: '1[3,4]_-23_', key: '非经营性现金净流', color: 'red' },
  { value: '1__-2__', key: '每月现金流情况（含投资款）', color: 'red' },
  { value: 'payCurrents', key: '走账总计', color: 'red', notTo: true },
  { value: 'current', key: '银行实时余额', color: 'red', notTo: true },
  {
    value: 'financeCurrentMap',
    key: '截止理财余额 ',
    color: 'red',
    notTo: true,
  },
  { value: 'financeCurrent', key: '可用资金总余额', color: 'red', notTo: true },
];

const loadDictExpend = () => {
  return new Promise((resolve, reject) => {
    queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        resolve(res.data);
      }
    });
  });
};

/**
 * 获取收入类别
 */
const loadDictIncome = () => {
  return new Promise((resolve, reject) => {
    queryDictIncome().then(res => {
      if (res.statusCode === 200) {
        resolve(res.data);
      }
    });
  });
};

const setItem = (item, key) => {
  if (!item.children) {
    item.children = [];
  }
  if (item.children.indexOf(key) < 0) {
    item.children.push(key);
  }
};

const getAllType = (pTypes, typeArr) => {
  const indexArr = [];
  const [income, expend] = typeArr;
  const reg11 = /^11.$/;
  const reg12 = /^12.$/;
  const reg13 = /^13.$/;
  const reg14 = /^14.$/;
  const reg21 = /^21.$/;
  const reg22 = /^22.$/;
  const reg23 = /^23.$/;
  const reg24 = /^24.$/;
  let parentValue = '';
  let type = pTypes;
  let no = 1;
  income.map((item, index) => {
    item.index = no++;
    if (reg11.test(item.value)) {
      parentValue = '11_';
    } else if (reg12.test(item.value)) {
      parentValue = '12_';
    } else if (reg13.test(item.value)) {
      parentValue = '13_';
    } else if (reg14.test(item.value)) {
      parentValue = '14_';
    }
    type = type.map((item2, index2) => {
      if (item2.value === parentValue) {
        setItem(item2, item.value);
      } else if ((parentValue === '11_' || parentValue === '12_') && item2.value === '1[1,2]_') {
        setItem(item2, item.value);
      } else if (
        (parentValue === '11_' || parentValue === '12_') &&
        item2.value === '1[1,2]_-2[1,2]_'
      ) {
        setItem(item2, item.value);
      } else if (
        (parentValue === '13_' || parentValue === '14_') &&
        item2.value === '1[3,4]_-23_'
      ) {
        setItem(item2, item.value);
      } else if (item2.value === '11_-21_' && parentValue === '11_') {
        setItem(item2, item.value);
      } else if (item2.value === '12_-22_' && parentValue === '12_') {
        setItem(item2, item.value);
      } else if (item2.value === '1__' || item2.value === '1__-2__') {
        setItem(item2, item.value);
      }
      return item2;
    });
    return income;
  });
  expend.forEach((item, index) => {
    item.index = no++;
    const flag = ['210', '211', '212', '21e', '21w', '216'];
    if (flag.includes(item.value)) {
      indexArr.push(item.index);
    }
    if (reg21.test(item.value)) {
      parentValue = '21_';
    } else if (reg22.test(item.value)) {
      parentValue = '22_';
    } else if (reg23.test(item.value)) {
      parentValue = '23_';
    } else if (reg24.test(item.value)) {
      parentValue = '24_';
    }
    type = type.map((item2, index2) => {
      if (item2.value === parentValue) {
        setItem(item2, item.value);
      } else if ((parentValue === '21_' || parentValue === '22_') && item2.value === '2[1,2]_') {
        setItem(item2, item.value);
      } else if (
        (parentValue === '21_' || parentValue === '22_') &&
        item2.value === '1[1,2]_-2[1,2]_'
      ) {
        setItem(item2, item.value);
      } else if (parentValue === '23_' && item2.value === '1[3,4]_-23_') {
        setItem(item2, item.value);
      } else if (item2.value === '11_-21_' && parentValue === '21_') {
        setItem(item2, item.value);
      } else if (item2.value === '12_-22_' && parentValue === '22_') {
        setItem(item2, item.value);
      } else if (item2.value === '2__' || item2.value === '1__-2__') {
        setItem(item2, item.value);
      }
      return item2;
    });
  });
  type = type.concat(expend).concat(income);
  type.map(item => {
    if (item.value === '[210,211,212,21e,21w,216]') {
      item.indexArr = indexArr;
    }
    return item;
  });
  return type;
};

const getIncomeExpendType = () => {
  return Promise.all([loadDictIncome(), loadDictExpend()]).then(res => {
    const type = getAllType(pType, res);
    return new Promise((resolve, reject) => {
      resolve(type);
    });
  });
};
export default getIncomeExpendType;



// WEBPACK FOOTER //
// ./src/util/getAllType.js